import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { BUSINESS } from "../constants/business";

const links = [
  { to: "/", label: "Home" },
  { to: "/estimate", label: "Submit an Estimate" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10" data-testid="main-nav">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo" onClick={() => setOpen(false)}>
          <span className="w-3 h-3 bg-[#E60000] group-hover:bg-[#FF3333] transition-colors" />
          <span className="font-display text-2xl tracking-wide uppercase leading-none pt-1">
            Mario <span className="text-zinc-500">Auto Body</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="nav-links-desktop">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `font-mono2 text-xs tracking-[0.2em] uppercase transition-colors ${
                  isActive ? "text-white" : "text-zinc-500 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href={BUSINESS.phoneHref}
            data-testid="nav-phone-link"
            className="hidden lg:flex items-center gap-2 font-mono2 text-xs tracking-[0.2em] text-zinc-400 hover:text-white transition-colors"
          >
            <Phone size={14} className="text-[#E60000]" /> {BUSINESS.phone}
          </a>
          <Link
            to="/estimate"
            data-testid="nav-get-estimate-btn"
            className="bg-[#E60000] hover:bg-[#FF3333] text-white font-bold uppercase tracking-wider text-xs px-6 py-3 transition-colors"
          >
            Get an Estimate
          </Link>
        </nav>

        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-menu-btn"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl" data-testid="nav-mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={() =>
                  `font-mono2 text-sm tracking-[0.2em] uppercase ${
                    location.pathname === l.to ? "text-[#E60000]" : "text-zinc-300"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/estimate"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-get-estimate-btn"
              className="bg-[#E60000] text-white text-center font-bold uppercase tracking-wider text-sm px-6 py-4 mt-2"
            >
              Get an Estimate
            </Link>
            <a href={BUSINESS.phoneHref} data-testid="nav-mobile-phone-link" className="font-mono2 text-sm text-zinc-400 flex items-center gap-2">
              <Phone size={14} className="text-[#E60000]" /> {BUSINESS.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
